export default __webpack_public_path__ + "static/media/elevator_ding.98f795ae.mp3";